import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    // Primary colors from Safar Go logo
    colorPrimary: '#1ABC9C',
    colorInfo: '#1ABC9C',
    colorSuccess: '#27AE60',
    colorWarning: '#F39C12',
    colorError: '#E74C3C',

    // Background colors (light theme)
    colorBgLayout: '#F0F2F5',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',

    // Text colors
    colorText: '#1a1a2e',
    colorTextSecondary: '#4a4a68',
    colorTextTertiary: '#8c8c8c',

    // Border
    colorBorder: '#e0e0e0',
    colorBorderSecondary: '#f0f0f0',

    // Border radius
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 6,

    // Font - DM Sans
    fontFamily: '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
  },
  components: {
    Layout: {
      siderBg: '#1a1a2e',
      headerBg: '#FFFFFF',
      bodyBg: '#F0F2F5',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkSubMenuItemBg: 'rgba(255, 255, 255, 0.03)',
      darkItemSelectedBg: 'linear-gradient(90deg, #1ABC9C 0%, #16A085 100%)',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.08)',
      darkItemColor: 'rgba(255, 255, 255, 0.65)',
      darkItemSelectedColor: '#FFFFFF',
      itemHeight: 44,
      itemMarginInline: 8,
      itemBorderRadius: 8,
    },
    Button: {
      primaryShadow: '0 4px 12px rgba(26, 188, 156, 0.35)',
      borderRadius: 8,
    },
    Card: {
      boxShadowTertiary: '0 2px 8px rgba(0, 0, 0, 0.06)',
      borderRadiusLG: 12,
    },
    Table: {
      headerBg: '#FAFAFA',
      rowHoverBg: '#F5F7FA',
      borderRadius: 10,
    },
    Input: {
      activeBorderColor: '#1ABC9C',
      hoverBorderColor: '#48C9B0',
      borderRadius: 8,
    },
    Select: {
      optionSelectedBg: '#E8F8F5',
      borderRadius: 8,
    },
  },
};
